import React from 'react';

const TextField = ({
  lable,
  placeholder,
  name,
  value,
  onChange,
  type,
  error,
  maxLength,
}) => (
  <div>
    <p className='font-semibold text-white'>{lable}</p>
    <input
      type={type}
      min={0.0001}
      step={0.0001}
      placeholder={placeholder}
      maxLength={maxLength && maxLength}
      className={`border-2 rounded-lg px-4 py-2 w-full !outline-none mt-2 bg-transparent text-white ${
        error ? 'border-red-500' : 'border-[#40A838]'
      }`}
      name={name}
      value={value}
      onChange={onChange}
    />
  </div>
);

export default TextField;
